import React, { Component } from "react";
import { connect } from "react-redux";
import { Page, Navbar, Toolbar, Button } from "framework7-react";
import arrayMutators from "final-form-arrays";

import Form from "modules/4_final_form/PersistedForm";
import HasRole from "modules/5_view_helpers/HasRole";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import { createStoreRequest } from "../actions";
import StoreRequestForm from "./form";

class NewStoreRequest extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    this.createRole = HasRole(
      {
        resource_type: "Store::Request",
        name: ["create", "moderator"],
      },
      true,
    );

    this.returnUrl = "/store/requests";
  }

  submitForm(values) {
    const {
      f7router: { app },
    } = this.props;
    this.preloader = app.preloader;
    this.preloader.show();
    this.props
      .createStoreRequest(values)
      .then(this.successfullySubmitted)
      .catch(() => {
        this.preloader.hide();
        app.toast
          .create({
            text: "Failed to create store request",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
      });
  }

  successfullySubmitted() {
    const {
      f7router,
      f7router: { app },
    } = this.props;

    this.preloader.hide();
    app.toast
      .create({
        icon: '<i class="material-icons">check</i>',
        text: "Created Store Request!",
        position: "center",
        closeTimeout: 2000,
        on: {
          opened: () => {
            f7router.navigate(this.returnUrl);
          },
        },
      })
      .open();
  }

  render() {
    if (!this.createRole) {
      return <NotAuthorized />;
    }

    return (
      <Page className="store-request-page">
        <Navbar title="New Store Request" backLink />

        <Toolbar bottom inner={false} className="store-request-toolbar">
          <div className="toolbar-inner store-request-toolbar-inner">
            <Button outline size="sm" onClick={() => this.addLine?.()}>
              Add item
            </Button>
            <Button fill size="sm" color="green" onClick={() => this.handleSubmit?.()}>
              Submit Request
            </Button>
          </div>
        </Toolbar>

        <Form
          onSubmit={this.submitForm}
          mutators={{ ...arrayMutators }}
          initialValues={{
            tool_account: false,
            line_items_attributes: [],
          }}
          render={(formProps) => {
            // ponytail: stash for page-level F7 toolbar
            this.handleSubmit = formProps.handleSubmit;
            this.addLine = () => formProps.form.mutators.push("line_items_attributes", { description: "", quantity: 1 });
            return <StoreRequestForm {...formProps} />;
          }}
        />
      </Page>
    );
  }
}

export default connect(null, { createStoreRequest })(NewStoreRequest);
